// Verifica se o circuito possui configurações manuais preenchidas, desconsiderando circuitos sincronizados via ERP
export default function isCircuitoConfigurado(circuit) {
	if (circuit?.syncedByErp) return false;
	return (
		!!circuit?.serial ||
		!!circuit?.blockIP ||
		!!circuit?.ipPublico ||
		!!circuit?.vlanId ||
		!!circuit?.companySideIPv4 ||
		!!circuit?.companySideIPv6 ||
		!!circuit?.clientIPv4 ||
		!!circuit?.clientIPv6 ||
		!!circuit?.observations ||
		!!circuit?.lastMilePartner?.partnerName ||
		!!circuit?.lastMilePartner?.partnerContact ||
		!!circuit?.endClient?.endClientName ||
		(circuit?.lastMilePartner?.partnerEnabled !== null &&
			circuit?.lastMilePartner?.partnerEnabled !== undefined) ||
		(circuit?.endClient?.endClientEnabled !== null &&
			circuit?.endClient?.endClientEnabled !== undefined) ||
		(circuit?.speed?.download !== null && circuit?.speed?.download !== undefined) ||
		(circuit?.speed?.upload !== null && circuit?.speed?.upload !== undefined)
	);
}
